import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';
import InputSlider from '../InputSlider';

import { Minus, Plus } from '../../../../assets/images';

import { WrapperZoom, ButtonZoom } from './style';

class ZoomSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.max ? this.props.max / 2 : 50
    };
    this.onClick = this.onClick.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  componentDidMount() {
    this.state.value = this.slider.state.value;
  }

  onClick(event) {
    const { max, min } = this.props;
    let val = Number(this.slider.state.value);
    if (
      event.target.name === 'minus' && this.slider.state.value > !min ? 0 : min
    ) {
      val -= 1;
    }
    if (
      event.target.name === 'plus' && this.slider.state.value < !max ? 100 : max
    ) {
      val += 1;
    }
    this.slider.setState({ value: val });
    this.setState({ value: val });
    event.preventDefault();
  }

  onChange = val => {
    this.slider.setState({ value: val });
    this.setState({ value: val });
    this.props.onChange(val);
  };

  render() {
    const { className, max, min } = this.props;
    const { value } = this.state;

    return (
      <WrapperZoom className={className}>
        <ButtonZoom onClick={this.onClick} name="minus">
          <Icon svg={Minus} hover={false} size="s" color="grayDarker" />
        </ButtonZoom>
        <InputSlider
          ref={slider => {
            this.slider = slider;
          }}
          val={parseInt(value, 0)}
          max={!max ? 100 : max}
          min={!min ? 0 : min}
          onChange={val => this.onChange(val)}
        />
        <ButtonZoom onClick={this.onClick} name="plus">
          <Icon svg={Plus} hover={false} size="s" color="grayDarker" />
        </ButtonZoom>
      </WrapperZoom>
    );
  }
}

ZoomSlider.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number
};

export default ZoomSlider;
